import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import ReactPlayer from "react-player";
import {useNavigate, useParams} from "react-router-dom";
import {getDomainInfo} from "../utils/utils";

function ImgOrVideo({ url, uid, pid, type, productName, skuId }) {
  const [onError, setOnError] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.5,
  });

  const { userId } = useParams();
  const { hostname, isPredefinedDomain } = getDomainInfo(userId);
  const navigate = useNavigate();
  
  const handleProductClick = (productId) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      navigate(
          isPredefinedDomain
              ? `/${uid}/productdetails/${productName}|${skuId ? skuId : ""}`
              : `/productdetails/${productName}|${skuId ? skuId : ""}`, {state : {productId: productId}}
      );
    }, 100);
  };

  if(!url){
    return;
  }

  const isS3Url = url.includes("https://hello-image-bucket.s3");
  
  const defaultImageUrl = process.env.REACT_APP_S3_URL || "default_url_if_missing";

  const imageUrl = isS3Url ? url : defaultImageUrl + url;
  return (
    <>
      {type === 1 ? (
        onError === false ? (
          <img width="100%"
            className="product-img"
            src={imageUrl}
            alt=""
            onError={() => setOnError(true)}
          />
        ) : (
          <div ref={ref} className="videoBox">
            <ReactPlayer
              url={imageUrl}
              playing={inView}
              controls={true}
              muted={true}
              loop={false}
              autoPlay={false}
              width={"100%"}
              height={"100%"}
              className="product-img"
            />
          </div>
        )
      ) : onError === false ? (
        <img
          onClick={() => handleProductClick(pid)}
          onError={() => setOnError(true)}
          src={imageUrl}
          alt=""
        />
      ) : (
        <video
          onClick={() => handleProductClick(pid)}
          width={"100%"}
          height={"100%"}
          autoPlay={true}
          loop
          muted={true}
          className="product-video-player"
        >
          <source
            src={imageUrl}
            type="video/mp4"
          />
        </video>
      )}
    </>
  );
}

export default ImgOrVideo;
